export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const TOGGLE_NAVIGATION_PHOTOS = 'TOGGLE_NAVIGATION_PHOTOS'
export const TOGGLE_NAVIGATION_WALLS = 'TOGGLE_NAVIGATION_WALLS'
export const TOGGLE_NAVIGATION_PRODUCTS = 'TOGGLE_NAVIGATION_PRODUCTS'
export const TOGGLE_NAVIGATION_FRAMES = 'TOGGLE_NAVIGATION_FRAMES'

export const TOGGLE_MODAL_FRAMES = 'TOGGLE_MODAL_FRAMES'



// WEBPACK FOOTER //
// ./src/constants/sidebarActions.js